function createBlobUrl(blobData, type = 'application/pdf') {
    return URL.createObjectURL(
        new Blob([blobData], {type})
    )
}

export { createBlobUrl };
